import { parseQueryParamsObject } from "@robe/core";
import { LinkableContent, ContentLinkOptions } from ".";
import { routeSlugPairFromContent } from "./routeSlugPairFromContent";
import { ID_REGEX, ContentLinkContextData, resolveRouting, SLUG_REGEX } from "./utils";

/**
 * Creates full url for content that corresponds to routes defined in DB.
 * Locally still resolved as path only, because host for local use is not defined in config.
 *
 * @example
 * - `https://example.com/painte`
 * - `https://example.com/registration/activation`
 */
export const as = (data: ContentLinkContextData) => (content: LinkableContent, options?: ContentLinkOptions) => {
  const {
    contentType,
    core: { locales },
  } = data;
  const { contentLocale, host } = resolveRouting(data, options);
  if (!contentLocale) {
    return null;
  }

  const routeAndSlug = routeSlugPairFromContent({ contentType, content, locales, contentLocale });
  if (!routeAndSlug || !routeAndSlug.route) {
    return null;
  }

  const routePath = resolveRoutePath(routeAndSlug.route.fromPath, content.id, routeAndSlug?.slug);
  if (!routePath) {
    return null;
  }

  const params = parseQueryParamsObject(options?.queries);
  const anchor = options?.anchor ? `#${options.anchor}` : "";

  return `${host ?? ""}${routePath}${params}${anchor}`;
};

const resolveRoutePath = (path: string, id: number, slug?: string | null) => {
  if (path.match(SLUG_REGEX)) {
    if (slug) {
      return path.replace(SLUG_REGEX, String(slug));
    }

    return null;
  }

  if (path.match(ID_REGEX)) {
    return path.replace(ID_REGEX, String(id));
  }

  return path;
};
